import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';
import { Dropdown } from '../ButtonWithDropdown/ButtonWithDropdown';
import { getQTipData } from '../Tooltip/qTip.utilities';
import type { QTipDataAttributes } from '../Tooltip/QTip.types';
import type { TriggerWithDropdownProps } from './TriggerWithDropdown.types';

const TriggerWithDropdown = ({ 'aria-busy': ariaBusy, ...rest }: TriggerWithDropdownProps) => {
  const { triggerIcon, id, extraClassNames = '', disabled = false, ...tooltipProps } = rest;

  const tooltipData: QTipDataAttributes | undefined = getQTipData(tooltipProps);

  return (
    <Dropdown {...rest}>
      <DropdownMenu.Trigger
        id={id}
        className={`
          tw:border-none
          tw:bg-transparent
          tw:focus-within:outline-none
          tw:focus:outline-none
          tw:focus-visible:outline-none
        `}
        aria-busy={ariaBusy}
        disabled={disabled}>
        <div
          {...tooltipData}
          className={clsx(
            `tw:flex
             tw:flex-col
             tw:items-center
             tw:bg-transparent
             tw:focus-within:outline-none
             tw:focus:outline-none
             tw:focus-visible:outline-none`,
            { 'tw:cursor-not-allowed tw:opacity-50': disabled },
            extraClassNames,
          )}>
          {triggerIcon}
        </div>
      </DropdownMenu.Trigger>
    </Dropdown>
  );
};

export default TriggerWithDropdown;
